<template>
    <form @submit.prevent="onSubmit" class="form-horizontal form-material">
        <div class="card text-white bg-danger" v-if="showFailureMessage">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Validation Errors</h4></div>
            <div class="card-body">
                <p v-if="typeof errors === 'string'" class="card-text">{{errors}}</p>
                <p v-else class="card-text" v-for="(error, key) in errors" :key="key">
                    {{key}}: {{error}}
                </p>
            </div>
        </div>
        <br/>

        <div class="mb-5" v-if="this.$store.getters.isAdmin">
            <label>Owner:</label>
            <treeselect placeholder="Select User"
                        v-model="socks.user"
                        :multiple="false"
                        :options="userList"
                        :load-options="loadUserList"
                        value-format="object"
            />
        </div>
        <div class="form-group">
            <label class="mb-1">IP:</label>
            <input v-model="socks.ip" type="text" class="form-control">
            <div v-if="$v.socks.ip.$error">
                <div class="text-danger" v-if="!$v.socks.ip.required">IP is required.</div>
                <div class="text-danger" v-if="!$v.socks.ip.ipAddress">Not valid IP address</div>
            </div>
        </div>
        <div class="form-group">
            <label class="mb-1">Port:</label>
            <input v-model.number="socks.port" type="text" class="form-control">
            <div v-if="$v.socks.port.$error">
                <div class="text-danger" v-if="!$v.socks.port.required">Port is required.</div>
                <div class="text-danger" v-if="!$v.socks.port.integer">Port must be integer.</div>
            </div>
        </div>
        <div class="form-group">
            <label class="mb-1">Login:</label>
            <input v-model="socks.login" type="text" class="form-control">
        </div>
        <div class="form-group">
            <label class="mb-1">Password:</label>
            <input v-model="socks.password" type="text" class="form-control">
        </div>
        <div class="form-group">
            <label class="custom-control custom-checkbox m-b-0">
                <input v-model="socks.active" type="checkbox" class="custom-control-input">
                <span class="custom-control-label">Active</span>
            </label>
        </div>
        <div class="form-group text-center p-b-20">
            <div class="col-xs-12">
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" v-show="!submitting">
                    Save
                </button>
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" disabled
                        v-show="submitting">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Submitting...
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import {integer, required, ipAddress} from 'vuelidate/lib/validators';
    import SocksProxyService from '../../services/SocksProxyService';
    import Treeselect from '@riophae/vue-treeselect';
    import UserService from '../../services/UserService';

    export default {
        name: 'SocksProxyForm',
        props: ['id'],
        components: {Treeselect},
        data() {
            return {
                socks: {
                    id: null,
                    ip: null,
                    port: null,
                    login: null,
                    password: null,
                    active: false,
                    user: null
                },
                errors: {},
                showFailureMessage: false,
                userList: null,
                submitting: false,
            }
        },
        mounted() {
            if (this.id) {
                SocksProxyService.getSocksProxy(this.id).then(response => {
                    this.socks = response.data;
                    this.$emit('hidePreloader', false)
                });
            }
        },
        validations: {
            socks: {
                ip: {required, ipAddress},
                port: {required, integer},
            }
        },
        methods: {
            onSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid) return;
                if (!this.socks.user) {
                    delete this.socks.user;
                }

                this.submitting = true;
                let submitMethod = null;
                if (this.id) {
                    submitMethod = SocksProxyService.updateSocksProxy(this.id, JSON.stringify(this.socks));
                } else {
                    submitMethod = SocksProxyService.createSocksProxy(JSON.stringify(this.socks));
                }

                submitMethod.then(response => {
                    if ([200, 201].includes(response.status)) {
                        this.$router.push({name: 'socksProxies'});
                    }
                    this.submitting = false;
                    this.errors = response.data.error !== undefined ? response.data.error : 'Some error occurred.';
                    this.showFailureMessage = true;
                }).catch(error => {
                    this.submitting = false;
                    this.errors = error.response.data.error;
                    this.showFailureMessage = true;
                });
            },
            loadUserList({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userList = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            }
        }
    }
</script>

<style scoped>

</style>
